import { useEffect, useState } from 'react';
import CampaignItem from './CampaignItem';
import { listCampaigns } from '../../api/challenges';
import './Campaign.css';

export async function loader() {
  return {};
}

export async function action() {}

function Campaign() {
  const [campaigns, setCampaigns] = useState([]);
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState('');

  useEffect(() => {
    let ignore = false;

    async function loadCampaigns() {
      try {
        setStatus('loading');
        const data = await listCampaigns();
        if (!ignore) {
          setCampaigns(data);
          setStatus('ready');
        }
      } catch (err) {
        if (!ignore) {
          setError(err.message);
          setStatus('error');
        }
      }
    }

    loadCampaigns();
    return () => {
      ignore = true;
    };
  }, []);

  if (status === 'loading') {
    return <div className="htv-state">Đang tải hành trình...</div>;
  }

  if (status === 'error') {
    return <div className="htv-state">Không tải được hành trình. {error}</div>;
  }

  return (
    <section className="campaign-discover">
      <div className="campaign-hero-copy">
        {/* <p className="htv-muted">Virtual challenge nội bộ</p> */}
        <h1 className="htv-section-title">Mỗi km là một chặng trên bản đồ Việt Nam.</h1>
        <p className="htv-muted">
          Chọn một hành trình, đăng ký miễn phí, rồi cùng đồng đội lấp đầy tuyến tiếp sức.
        </p>
      </div>

      {/* <div className="campaign-filter-row" aria-label="Bộ lọc nhanh">
        <span className="htv-pill">Tất cả</span>
        <span className="htv-pill">Dưới 100 km</span>
        <span className="htv-pill">100-500 km</span>
        <span className="htv-pill">Trên 500 km</span>
      </div> */}

      {campaigns.length === 0 ? (
        <div className="htv-state">Chưa có hành trình nào.</div>
      ) : (
        <div className="campaign-grid">
          {campaigns.map((campaign) => (
            <CampaignItem campaign={campaign} key={campaign.id} />
          ))}
        </div>
      )}
    </section>
  );
}

export default Campaign;
